// generated by genversion
export var version = '4.2.8';
//# sourceMappingURL=version.js.map